import * as PropTypes from 'prop-types';
export var propTypes = {
  accessibilityExpanded: PropTypes.bool,
  accessibilityHaspopup: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  block: PropTypes.bool,
  reverseColor: PropTypes.bool,
  color: PropTypes.oneOf(['red', 'grey', 'white']),
  kind: PropTypes.oneOf(['primary', 'secondary']),
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  spinner: PropTypes.bool,
  onClickCapture: PropTypes.func,
  'data-id': PropTypes.string,
  trackingDisabled: PropTypes.bool
};